export default {
    url: '/rolling',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 894,
        title: 'Rolling',
    },
    controller: [
        '$scope',
        'jsonrpc',
        function($scope, jsonrpc) {
            $scope.get_data_method = jsonrpc.newServiceMethod('retention.rolling');
        },
    ],
}
